import * as Constants from '../constants/';
import { lastXDays } from '../../common/utilities/dateRangeHelper';

const initialState = {
  isLoading: false,
  error: null,
  data: {
    filter: {
      // WARNING: this is linked to the ReportFilter default on the <DateRange> component line #37
      ...lastXDays(7).dates
    },
    available: []
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_REPORTS:
      return { ...state, isLoading: true };
    case Constants.RECEIVE_REPORTS:
      if (action.error) {
        return {
          ...state,
          isLoading: false,
          error: action.error
        };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          ...action.data
        }
      };
    case Constants.MODIFY_REPORTS_FILTER:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          filter: { ...action.filter },
          available: []
        }
      };
    default:
      return state;
  }
}
